"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const connector = (0, react_redux_1.connect)((state) => ({}), (dispatch) => ({}));
exports.default = connector(({ Component, auth, preCheck }) => {
    // return <Component auth={null} />;
    return react_1.default.createElement(Component, { auth: auth });
    // return (
    //   <Suspense fallback={<Loading />}>
    //     {/* {props.hasNav && <NavBar {...props} />} */}
    //     <>
    //       {!preCheck ? (
    //         <Loading />
    //       ) : !auth.id ? (
    //         <Component auth={null} />
    //       ) : (
    //         <Component auth={auth} />
    //       )}
    //     </>
    //     {/* {props.hasFooter && <Footer />} */}
    //   </Suspense>
    // );
});
